import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {Stack} from '@primer/react'

import styles from './SpaceLoader.module.css'

interface SkeletonProps {
  height: string
  width: string
}

interface SpaceLoaderProps {
  variant?: 'conversation' | 'administration'
}

function Skeleton({height, width}: SkeletonProps) {
  return (
    <LoadingSkeleton animationStyle="pulse" height={height} variant="rounded" width={width} data-testid="skeleton" />
  )
}

export function SpaceLoader({variant = 'conversation'}: SpaceLoaderProps) {
  const isAdministration = variant === 'administration'

  return (
    <div className={styles.container}>
      <div role="region" aria-label="Loading space" className={styles.wrapper}>
        <Stack direction="vertical" gap="spacious">
          <Skeleton height="22px" width="10%" />
          <Skeleton height="42px" width="40%" />
          <Skeleton height="32px" width="60%" />
          {!isAdministration && <Skeleton height="105px" width="100%" />}
          <Skeleton height="125px" width="100%" />
          <Stack direction="horizontal" className={styles.horizontalStack}>
            <Stack direction="horizontal" gap="normal" className={styles.leftGroup}>
              <Skeleton height="32px" width="30%" />
              {!isAdministration && <Skeleton height="32px" width="40%" />}
            </Stack>
            <Skeleton height="32px" width="17%" />
          </Stack>
          <Skeleton height={isAdministration ? '105px' : '300px'} width="100%" />
          {isAdministration && (
            <Stack direction="vertical" gap="condensed" className={styles.visibilityStack}>
              <Skeleton height="20px" width="10%" />
              <Skeleton height="32px" width="17%" />
            </Stack>
          )}
        </Stack>
      </div>
    </div>
  )
}
